import { render, staticRenderFns } from "./SaneamentoChecklist.vue?vue&type=template&id=fdd1f50a"
import script from "./SaneamentoChecklist.vue?vue&type=script&lang=js"
export * from "./SaneamentoChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports